import { createApp } from "vue";

import 'maz-ui/css/main.css'

import 'vue-select/dist/vue-select.css';

import App from "./App.vue";
import store from "./store";
import keys from '@/store/keys'
import router from "./router";
import API from '@/store/axios';
import PromSleep from '@/store/config';
import  VueGoogleMaps from '@fawmi/vue-google-maps';

import PinInput from 'v-pin-input'
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import LoadScript from "vue-plugin-load-script";

import Toaster from '@meforma/vue-toaster';
import { vfmPlugin } from 'vue-final-modal'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { JSEncrypt } from 'jsencrypt'
import { Skeletor } from 'vue-skeletor';
import ReadMore from 'vue-read-more';
import VLazyImage from "v-lazy-image";

import vSelect from "vue-select";
import VueCleave from 'vue-cleave-component';
import Emittery from 'emittery';
import { toastMixin } from './mixins/toastMixin';


const encryptBackoffice = new JSEncrypt()
encryptBackoffice.setPublicKey(keys.publicKeyBackoffice)

const ua = navigator.userAgent

let isMobile=false;

if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
  console.log('Es mobile');
  //es mobile
isMobile=true;
} else {
  console.log('Es desktop');
 //es destopk
 isMobile=false;

}

const appInstance = createApp(App);
appInstance.component('MazPhoneNumberInput', MazPhoneNumberInput)


appInstance.config.globalProperties.$encryptBackoffice = encryptBackoffice;
appInstance.config.globalProperties.$https = API;

// Registrar el mixin globalmente
appInstance.mixin(toastMixin)

const promSleep = new PromSleep();
appInstance.config.globalProperties.$sleepTimer = promSleep;

appInstance.config.globalProperties.$isMobile = isMobile;
appInstance.config.globalProperties.$eventBus = new Emittery();
appInstance.use(store);
appInstance.use(router);
appInstance.use(ReadMore);



appInstance.use(VueCleave);
appInstance.use(LoadScript);
appInstance.use(VueGoogleMaps, {
  load: {
      key: 'AIzaSyDAlcyvEoB_DzBgF4JMqr88HZViABFr8nY',
  },
})

appInstance.component('v-select', vSelect);
appInstance.component('v-lazy-image', VLazyImage);

appInstance.component(Skeletor.name, Skeletor);
appInstance.use(VueSweetalert2);
appInstance.use(Toaster);
appInstance.use(vfmPlugin);
appInstance.use(PinInput)

appInstance.use(ArgonDashboard);
appInstance.mount("#app");
